export default "https://cdn-static.gokick.com/assets/f3c431ab621bc71377aad81f5421d83f1421a0d2/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";